module.exports = __webpack_public_path__ + "img/psd.7eab5859.png";